import { Exclude, Type } from 'class-transformer';
import { IsBoolean, IsDate, IsInt, IsOptional, IsString, Length } from 'class-validator';
import { NpsPieMerchantCreateDto } from './nps-pie-merchant-create.dto';

export class NpsUpdateDto {
  @IsOptional()
  @IsInt()
  @Type(() => Number)
  npsSurveyId?: number;

  @IsOptional()
  @IsDate()
  @Type(() => Date)
  startDate?: Date;

  @IsOptional()
  @IsDate()
  @Type(() => Date)
  endDate?: Date;

  @IsOptional()
  @IsBoolean()
  isActive?: boolean;
}
